var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('div',[_vm._v(_vm._s(_vm.node.dateStart))]),_c('div',[_vm._v(_vm._s(_vm.node.dateEnd))]),(_vm.$parent.scrollTop > 50)?_c('div',{staticClass:"ghost"},[_c('div',[_vm._v(_vm._s(_vm.node.dateEnd))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }